webpackJsonp([1],{

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Presenter_vue__ = __webpack_require__(250);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6a157ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Presenter_vue__ = __webpack_require__(291);
function injectStyle (ssrContext) {
  __webpack_require__(289)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Presenter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6a157ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Presenter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__slide_elements_TextElement__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slide_elements_ImageElement__ = __webpack_require__(235);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'current-slide',
  props: {
    slides: { type: Array, default: [] },
    selectedSlideIndex: { type: Number, default: 0 },
    zoomLevel: { type: Number, default: 1 }
  },
  components: {
    'text-element': __WEBPACK_IMPORTED_MODULE_0__slide_elements_TextElement__["a" /* default */],
    'image-element': __WEBPACK_IMPORTED_MODULE_1__slide_elements_ImageElement__["a" /* default */]
  },
  computed: {
    currentSlide: function currentSlide() {
      return this.slides.length && this.slides[this.selectedSlideIndex] ? this.slides[this.selectedSlideIndex] : null;
    },
    textElements: function textElements() {
      return this.currentSlide ? this.currentSlide.elements.filter(function (el) {
        return el.type === 'TEXT';
      }) : [];
    },
    imageElements: function imageElements() {
      return this.currentSlide ? this.currentSlide.elements.filter(function (el) {
        return el.type === 'IMAGE';
      }) : [];
    },
    slideProperties: function slideProperties() {
      return {
        '--canvas-zoom-level': this.zoomLevel,
        '--canvas-background-colour': this.currentSlide ? this.currentSlide.backgroundColour : '#FFFFFF'
      };
    },
    presenterMode: function presenterMode() {
      return this.$route.name === 'presenter';
    }
  }
});

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementWrapper__ = __webpack_require__(215);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'text-element',
  components: {
    'element-wrapper': __WEBPACK_IMPORTED_MODULE_0__ElementWrapper__["a" /* default */]
  },
  props: { element: Object },
  computed: {
    textX: function textX() {
      return this.element.properties.x;
    },
    textY: function textY() {
      return this.element.properties.y;
    },
    fontFamily: function fontFamily() {
      return this.element.properties.fontFamily;
    },
    fontSize: function fontSize() {
      return this.element.properties.fontSize;
    },
    content: function content() {
      return this.element.properties.content;
    },
    fill: function fill() {
      return this.element.properties.fill;
    }
  }
});

/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ElementWrapper_vue__ = __webpack_require__(216);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_605053b3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ElementWrapper_vue__ = __webpack_require__(233);
function injectStyle (ssrContext) {
  __webpack_require__(227)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-605053b3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ElementWrapper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_605053b3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ElementWrapper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InspectingUserLabel__ = __webpack_require__(229);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'element-wrapper',
  props: {
    element: Object
  },
  components: {
    'inspecting-user-label': __WEBPACK_IMPORTED_MODULE_3__InspectingUserLabel__["a" /* default */]
  },
  data: function data() {
    return {
      actualEl: null,
      bbox: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('editor', ['selectedElementIndex']), {
    computedStyles: function computedStyles() {
      return {
        'inspecting': this.selectedElementIndex === this.element.id
      };
    },
    containerX: function containerX() {
      return this.bbox ? this.bbox.x - 10 : 0;
    },
    containerY: function containerY() {
      return this.bbox ? this.bbox.y - 10 : 0;
    },
    containerWidth: function containerWidth() {
      return this.bbox ? this.bbox.width + 20 : 0;
    },
    containerHeight: function containerHeight() {
      return this.bbox ? this.bbox.height + 20 : 0;
    }
  }),
  watch: {
    element: {
      handler: function handler() {
        return this.updateBBox(this.actualEl);
      },
      deep: true
    },
    currentElement: {
      handler: function handler() {
        return this.updateBBox(this.actualEl);
      },
      deep: true
    },
    currentSlide: {
      handler: function handler() {
        return this.updateBBox(this.actualEl);
      },
      deep: true
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('editor', ['inspectElement', 'currentElement', 'currentSlide', 'updateCoordinates']), __WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* default */]),
  mounted: function mounted() {
    this.actualEl = this.$slots['actual-element'][0].elm;
    this.updateBBox(this.actualEl);
  }
});

/***/ }),

/***/ 217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  updateBBox: function updateBBox(el) {
    var _this = this;

    return this.$nextTick(function () {
      try {
        _this.bbox = el.getBBox();
      } catch (_) {
        // Workaround for FF bug #612118 (https://bugzilla.mozilla.org/show_bug.cgi?id=612118)
        // getBBox() will throw an exception if the element
        // is not attached and rendered, but there is no reliable way to check for this
        setTimeout(function () {
          // Try again in 3 seconds
          _this.updateBBox(el);
        }, 3000);
      }
    });
  }
});

/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(217);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inspecting-user-label',
  props: {
    x: Number,
    y: Number
  },
  data: function data() {
    return {
      bbox: null
    };
  },

  computed: {
    containerX: function containerX() {
      return this.bbox ? this.bbox.x - 10 : 0;
    },
    containerY: function containerY() {
      return this.bbox ? this.bbox.y - 10 : 0;
    },
    containerWidth: function containerWidth() {
      return this.bbox ? this.bbox.width + 20 : 0;
    },
    containerHeight: function containerHeight() {
      return this.bbox ? this.bbox.height + 20 : 0;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* default */]),
  watch: {
    element: {
      handler: function handler() {
        return this.updateBBox(this.actualEl);
      },
      deep: true
    },
    currentElement: {
      handler: function handler() {
        return this.updateBBox(this.actualEl);
      },
      deep: true
    },
    currentSlide: {
      handler: function handler() {
        return this.updateBBox(this.actualEl);
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.updateBBox(this.$refs.textEl, this);
  }
});

/***/ }),

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementWrapper__ = __webpack_require__(215);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'image-element',
  components: {
    'element-wrapper': __WEBPACK_IMPORTED_MODULE_0__ElementWrapper__["a" /* default */]
  },
  props: { element: Object },
  computed: {
    href: function href() {
      return this.element.properties.href;
    },
    x: function x() {
      return this.element.properties.x;
    },
    y: function y() {
      return this.element.properties.y;
    },
    width: function width() {
      return this.element.properties.width;
    },
    height: function height() {
      return this.element.properties.height;
    }
  }
});

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentSlide_vue__ = __webpack_require__(213);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbe657dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentSlide_vue__ = __webpack_require__(239);
function injectStyle (ssrContext) {
  __webpack_require__(222)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurrentSlide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbe657dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurrentSlide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(223);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(205)("5bb3c499", content, true, {});

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(204)(true);
// imports


// module
exports.push([module.i, ".current-slide{grid-area:current-slide;grid-row:1/-1;overflow:hidden;display:grid;-webkit-box-align:center;-ms-flex-align:center;align-items:center;justify-items:center}.editor .current-slide{padding:3em}.presenter .current-slide svg{width:100vw;height:60vw;max-height:100vh;max-width:166.66vh}.current-slide svg{background-color:var(--canvas-background-colour);outline:3px solid rgba(0,0,0,.2);-webkit-box-shadow:0 0 15px rgba(0,0,0,.7);box-shadow:0 0 15px rgba(0,0,0,.7);-webkit-transform:scale(var(--canvas-zoom-level));transform:scale(var(--canvas-zoom-level))}.current-slide svg .hoverableElement .hoverState{visibility:hidden}.current-slide svg .hoverableElement:hover .hoverState{visibility:visible;fill:none;stroke:rgba(0,0,0,.4);stroke-width:2px;stroke-dasharray:4;stroke-linecap:square}.current-slide svg .hoverableElement:hover{cursor:move}.presenter .current-slide{background-color:#000;padding:0}.presenter .current-slide svg{background-color:var(--canvas-background-colour);outline:none;-webkit-box-shadow:none;box-shadow:none}.presenter .current-slide,.presenter .current-slide>*{cursor:default}@-webkit-keyframes fadeIn{0%{opacity:1}to{opacity:0}}@keyframes fadeIn{0%{opacity:1}to{opacity:0}}@-webkit-keyframes slideDown{0%{opacity:.5;-webkit-transform:translateY(-100%);transform:translateY(-100%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes slideDown{0%{opacity:.5;-webkit-transform:translateY(-100%);transform:translateY(-100%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@-webkit-keyframes slideUp{0%{opacity:.5;-webkit-transform:translateY(100%);transform:translateY(100%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes slideUp{0%{opacity:.5;-webkit-transform:translateY(100%);transform:translateY(100%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@-webkit-keyframes slideInRight{0%{opacity:.5;-webkit-transform:translateX(100%);transform:translateX(100%)}to{opacity:1;-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes slideInRight{0%{opacity:.5;-webkit-transform:translateX(100%);transform:translateX(100%)}to{opacity:1;-webkit-transform:translateX(0);transform:translateX(0)}}@-webkit-keyframes scaleIn{0%{opacity:.5;-webkit-transform:scale(.5);transform:scale(.5)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@keyframes scaleIn{0%{opacity:.5;-webkit-transform:scale(.5);transform:scale(.5)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}.presenter .current-slide.fadeIn:before{content:\"\";position:absolute;top:0;left:0;right:0;bottom:0;opacity:0;background-color:#fff;z-index:10;-webkit-animation:1s ease-in-out .1s 1 fadeIn;animation:1s ease-in-out .1s 1 fadeIn}.presenter .current-slide.slideDown{-webkit-animation:.4s ease-in-out .1s 1 slideDown;animation:.4s ease-in-out .1s 1 slideDown;-webkit-transform:none;transform:none}.presenter .current-slide.slideUp{-webkit-animation:.4s ease-in-out .1s 1 slideUp;animation:.4s ease-in-out .1s 1 slideUp;-webkit-transform:none;transform:none}.presenter .current-slide.slideInRight{-webkit-animation:.4s ease-in-out .1s 1 slideInRight;animation:.4s ease-in-out .1s 1 slideInRight;-webkit-transform:none;transform:none}.presenter .current-slide.scaleIn{-webkit-animation:.4s ease-in-out .1s 1 scaleIn;animation:.4s ease-in-out .1s 1 scaleIn;-webkit-transform:none;transform:none}", "", {"version":3,"sources":["/home/forge/slidekick.daniel-waghorn.com/src/components/CurrentSlide.vue"],"names":[],"mappings":"AACA,eACE,wBAAyB,AACzB,cAAiB,AAEjB,gBAAiB,AACjB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAsB,CACvB,AACD,uBACE,WAAa,CACd,AACD,8BAGE,YAAa,AACb,YAAa,AACb,iBAAkB,AAClB,kBAAoB,CACrB,AACD,mBACE,iDAAkD,AAClD,iCAAsC,AACtC,2CAAgD,AACxC,mCAAwC,AAEhD,kDAAmD,AAE3C,yCAA2C,CACpD,AACD,iDACE,iBAAmB,CACpB,AACD,uDACE,mBAAoB,AACpB,UAAW,AACX,sBAA2B,AAC3B,iBAAkB,AAClB,mBAAoB,AACpB,qBAAuB,CACxB,AACD,2CACE,WAAa,CACd,AACD,0BACE,sBAAwB,AACxB,SAAW,CACZ,AACD,8BACE,iDAAkD,AAClD,aAAc,AACd,wBAAyB,AACjB,eAAiB,CAC1B,AACD,sDAEE,cAAgB,CACjB,AACD,0BACA,GACI,SAAW,CACd,AACD,GACI,SAAW,CACd,CACA,AACD,kBACA,GACI,SAAW,CACd,AACD,GACI,SAAW,CACd,CACA,AACD,6BACA,GACI,WAAa,AACb,oCAAqC,AAC7B,2BAA6B,CACxC,AACD,GACI,UAAW,AACX,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,qBACA,GACI,WAAa,AACb,oCAAqC,AAC7B,2BAA6B,CACxC,AACD,GACI,UAAW,AACX,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,2BACA,GACI,WAAa,AACb,mCAAoC,AAC5B,0BAA4B,CACvC,AACD,GACI,UAAW,AACX,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,mBACA,GACI,WAAa,AACb,mCAAoC,AAC5B,0BAA4B,CACvC,AACD,GACI,UAAW,AACX,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,gCACA,GACI,WAAa,AACb,mCAAoC,AAC5B,0BAA4B,CACvC,AACD,GACI,UAAW,AACX,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,wBACA,GACI,WAAa,AACb,mCAAoC,AAC5B,0BAA4B,CACvC,AACD,GACI,UAAW,AACX,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,2BACA,GACI,WAAa,AACb,4BAA8B,AACtB,mBAAsB,CACjC,AACD,GACI,UAAW,AACX,2BAA4B,AACpB,kBAAoB,CAC/B,CACA,AACD,mBACA,GACI,WAAa,AACb,4BAA8B,AACtB,mBAAsB,CACjC,AACD,GACI,UAAW,AACX,2BAA4B,AACpB,kBAAoB,CAC/B,CACA,AACD,wCACE,WAAY,AACZ,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,UAAW,AACX,sBAAwB,AACxB,WAAY,AACZ,8CAAgD,AACxC,qCAAwC,CACjD,AACD,oCACE,kDAAqD,AAC7C,0CAA6C,AACrD,uBAAwB,AAChB,cAAgB,CACzB,AACD,kCACE,gDAAmD,AAC3C,wCAA2C,AACnD,uBAAwB,AAChB,cAAgB,CACzB,AACD,uCACE,qDAAwD,AAChD,6CAAgD,AACxD,uBAAwB,AAChB,cAAgB,CACzB,AACD,kCACE,gDAAmD,AAC3C,wCAA2C,AACnD,uBAAwB,AAChB,cAAgB,CACzB","file":"CurrentSlide.vue","sourcesContent":["\n.current-slide {\n  grid-area: current-slide;\n  grid-row: 1 / -1;\n  \n  overflow: hidden;\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  justify-items: center;\n}\n.editor .current-slide {\n  padding: 3em;\n}\n.presenter .current-slide svg {\n  /* Styles to preserve 5:3 aspect ratio */\n\n  width: 100vw;\n  height: 60vw; /* 3/5 = 0.6 */\n  max-height: 100vh;\n  max-width: 166.66vh; /* 5/3 = 1.6666 */\n}\n.current-slide svg {\n  background-color: var(--canvas-background-colour);\n  outline: 3px solid rgba(0, 0, 0, 0.2);\n  -webkit-box-shadow: 0 0 15px rgba(0, 0, 0, 0.7);\n          box-shadow: 0 0 15px rgba(0, 0, 0, 0.7);\n  \n  -webkit-transform: scale(var(--canvas-zoom-level));\n  \n          transform: scale(var(--canvas-zoom-level));\n}\n.current-slide svg .hoverableElement .hoverState {\n  visibility: hidden;\n}\n.current-slide svg .hoverableElement:hover .hoverState {\n  visibility: visible;\n  fill: none;\n  stroke: rgba(0, 0, 0, 0.4);\n  stroke-width: 2px;\n  stroke-dasharray: 4;\n  stroke-linecap: square;\n}\n.current-slide svg .hoverableElement:hover {\n  cursor: move;\n}\n.presenter .current-slide {\n  background-color: black;\n  padding: 0;\n}\n.presenter .current-slide svg {\n  background-color: var(--canvas-background-colour);\n  outline: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.presenter .current-slide,\n.presenter .current-slide > * {\n  cursor: default;\n}\n@-webkit-keyframes fadeIn {\n0% {\n    opacity: 1;\n}\n100% {\n    opacity: 0;\n}\n}\n@keyframes fadeIn {\n0% {\n    opacity: 1;\n}\n100% {\n    opacity: 0;\n}\n}\n@-webkit-keyframes slideDown {\n0% {\n    opacity: 0.5;\n    -webkit-transform: translateY(-100%);\n            transform: translateY(-100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n}\n}\n@keyframes slideDown {\n0% {\n    opacity: 0.5;\n    -webkit-transform: translateY(-100%);\n            transform: translateY(-100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n}\n}\n@-webkit-keyframes slideUp {\n0% {\n    opacity: 0.5;\n    -webkit-transform: translateY(100%);\n            transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n}\n}\n@keyframes slideUp {\n0% {\n    opacity: 0.5;\n    -webkit-transform: translateY(100%);\n            transform: translateY(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n}\n}\n@-webkit-keyframes slideInRight {\n0% {\n    opacity: 0.5;\n    -webkit-transform: translateX(100%);\n            transform: translateX(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n}\n}\n@keyframes slideInRight {\n0% {\n    opacity: 0.5;\n    -webkit-transform: translateX(100%);\n            transform: translateX(100%);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n}\n}\n@-webkit-keyframes scaleIn {\n0% {\n    opacity: 0.5;\n    -webkit-transform: scale(0.5);\n            transform: scale(0.5);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n            transform: scale(1);\n}\n}\n@keyframes scaleIn {\n0% {\n    opacity: 0.5;\n    -webkit-transform: scale(0.5);\n            transform: scale(0.5);\n}\n100% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n            transform: scale(1);\n}\n}\n.presenter .current-slide.fadeIn::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  opacity: 0;\n  background-color: white;\n  z-index: 10;\n  -webkit-animation: 1s ease-in-out 0.1s 1 fadeIn;\n          animation: 1s ease-in-out 0.1s 1 fadeIn;\n}\n.presenter .current-slide.slideDown {\n  -webkit-animation: 0.4s ease-in-out 0.1s 1 slideDown;\n          animation: 0.4s ease-in-out 0.1s 1 slideDown;\n  -webkit-transform: none;\n          transform: none;\n}\n.presenter .current-slide.slideUp {\n  -webkit-animation: 0.4s ease-in-out 0.1s 1 slideUp;\n          animation: 0.4s ease-in-out 0.1s 1 slideUp;\n  -webkit-transform: none;\n          transform: none;\n}\n.presenter .current-slide.slideInRight {\n  -webkit-animation: 0.4s ease-in-out 0.1s 1 slideInRight;\n          animation: 0.4s ease-in-out 0.1s 1 slideInRight;\n  -webkit-transform: none;\n          transform: none;\n}\n.presenter .current-slide.scaleIn {\n  -webkit-animation: 0.4s ease-in-out 0.1s 1 scaleIn;\n          animation: 0.4s ease-in-out 0.1s 1 scaleIn;\n  -webkit-transform: none;\n          transform: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextElement_vue__ = __webpack_require__(214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_011b23b5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextElement_vue__ = __webpack_require__(234);
function injectStyle (ssrContext) {
  __webpack_require__(225)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextElement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_011b23b5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextElement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(226);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(205)("26770116", content, true, {});

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(204)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"TextElement.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(228);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(205)("80b7ec52", content, true, {});

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(204)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes rotateDashes-data-v-605053b3{0%{stroke-dashoffset:0}to{stroke-dashoffset:60}}@keyframes rotateDashes-data-v-605053b3{0%{stroke-dashoffset:0}to{stroke-dashoffset:60}}g[data-v-605053b3]:hover{cursor:pointer}g:hover .bbox[data-v-605053b3]{stroke:rgba(0,0,0,.4)}g.inspecting .bbox[data-v-605053b3]{stroke-linecap:round;stroke:rgba(0,0,0,.6);stroke-dasharray:15px;-webkit-animation:rotateDashes-data-v-605053b3 5s infinite linear;animation:rotateDashes-data-v-605053b3 5s infinite linear}", "", {"version":3,"sources":["/home/forge/slidekick.daniel-waghorn.com/src/components/slide-elements/ElementWrapper.vue"],"names":[],"mappings":"AACA,gDACA,GACI,mBAAqB,CACxB,AACD,GACI,oBAAsB,CACzB,CACA,AACD,wCACA,GACI,mBAAqB,CACxB,AACD,GACI,oBAAsB,CACzB,CACA,AACD,yBACE,cAAgB,CACjB,AACD,+BACE,qBAA2B,CAC5B,AACD,oCACE,qBAAsB,AACtB,sBAA2B,AAC3B,sBAAuB,AACvB,kEAAmE,AAC3D,yDAA2D,CACpE","file":"ElementWrapper.vue","sourcesContent":["\n@-webkit-keyframes rotateDashes-data-v-605053b3 {\n0% {\n    stroke-dashoffset: 0;\n}\n100% {\n    stroke-dashoffset: 60;\n}\n}\n@keyframes rotateDashes-data-v-605053b3 {\n0% {\n    stroke-dashoffset: 0;\n}\n100% {\n    stroke-dashoffset: 60;\n}\n}\ng[data-v-605053b3]:hover {\n  cursor: pointer;\n}\ng:hover .bbox[data-v-605053b3] {\n  stroke: rgba(0, 0, 0, 0.4);\n}\ng.inspecting .bbox[data-v-605053b3] {\n  stroke-linecap: round;\n  stroke: rgba(0, 0, 0, 0.6);\n  stroke-dasharray: 15px;\n  -webkit-animation: rotateDashes-data-v-605053b3 5s infinite linear;\n          animation: rotateDashes-data-v-605053b3 5s infinite linear;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InspectingUserLabel_vue__ = __webpack_require__(218);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c37738c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InspectingUserLabel_vue__ = __webpack_require__(232);
function injectStyle (ssrContext) {
  __webpack_require__(230)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InspectingUserLabel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c37738c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InspectingUserLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(231);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(205)("eed78194", content, true, {});

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(204)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"InspectingUserLabel.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('rect',{attrs:{"fill":"black","x":_vm.containerX,"y":_vm.containerY,"width":_vm.containerWidth,"height":_vm.containerHeight}}),_vm._v(" "),_c('text',{ref:"textEl",attrs:{"x":_vm.x,"y":_vm.y,"font-size":"10","font-weight":"bold","fill":"red"}},[_vm._v("\n    PAUL\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{class:_vm.computedStyles,on:{"click":function($event){$event.stopPropagation();_vm.inspectElement(_vm.element.id)},"mouseover":_vm.updateBBox}},[_c('rect',{staticClass:"bbox",attrs:{"width":_vm.containerWidth,"height":_vm.containerHeight,"x":_vm.containerX,"y":_vm.containerY,"fill":"none","stroke-width":"2px","stroke":"none"}}),_vm._v(" "),_vm._t("actual-element",[_c('text',{attrs:{"x":"0","y":"0","font-size":"12","fill":"black"}},[_vm._v("Unable to load element")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('element-wrapper',{attrs:{"element":_vm.element}},[_c('text',{attrs:{"slot":"actual-element","dominant-baseline":"hanging","x":_vm.textX,"y":_vm.textY,"font-family":_vm.fontFamily,"font-size":_vm.fontSize,"fill":_vm.fill},slot:"actual-element"},[_vm._v("\n    "+_vm._s(_vm.content)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageElement_vue__ = __webpack_require__(219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35dbfdd0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageElement_vue__ = __webpack_require__(238);
function injectStyle (ssrContext) {
  __webpack_require__(236)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageElement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35dbfdd0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageElement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(237);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(205)("9a5252f8", content, true, {});

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(204)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ImageElement.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('element-wrapper',{attrs:{"element":_vm.element}},[_c('image',{attrs:{"slot":"actual-element","x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"href":_vm.href},slot:"actual-element"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"current-slide"},[_c('svg',{style:(_vm.slideProperties),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 300","preserveAspectRatio":"xMinYMax meet"}},[_vm._l((_vm.imageElements.reverse()),function(imageElement){return _c('image-element',{key:imageElement.id,attrs:{"element":imageElement}})}),_vm._v(" "),_vm._l((_vm.textElements.reverse()),function(textElement){return _c('text-element',{key:textElement.id,attrs:{"element":textElement}})})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CurrentSlide_vue__ = __webpack_require__(221);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'presenter',
  components: {
    'current-slide': __WEBPACK_IMPORTED_MODULE_2__CurrentSlide_vue__["a" /* default */]
  },
  data: function data() {
    return {
      fullscreen: false,
      showUI: false,
      movemoveTimerActive: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('presenter', ['presentation', 'selectedSlideIndex', 'slides']), {
    computedStyles: function computedStyles() {
      return {
        'ui-hidden': !this.showUI
      };
    },
    supportsFullscreen: function supportsFullscreen() {
      var element = document.querySelector('body');
      return element.requestFullscreen || element.mozRequestFullScreen || element.webkitRequestFullscreen || element.msRequestFullscreen;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('presenter', ['next', 'previous']), {
    enterFullscreen: function enterFullscreen() {
      var element = document.querySelector('.presenter');
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    },
    exitFullscreen: function exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    },
    onFullscreenChange: function onFullscreenChange(e) {
      this.fullscreen = document.fullscreen || document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
    },
    onKeyup: function onKeyup(e) {
      e.preventDefault();
      switch (e.keyCode) {
        case 37:
          this.previous();
          break;
        case 39:
          this.next();
          break;
      }
    },
    onMousemove: function onMousemove() {
      var _this = this;

      if (this.movemoveTimerActive) {
        return;
      }

      this.showUI = true;
      this.movemoveTimerActive = true;

      setTimeout(function () {
        _this.showUI = false;
        _this.movemoveTimerActive = false;
      }, 5000);
    },
    touchscreenTrigger: function touchscreenTrigger() {
      this.onMousemove();
    }
  }),
  created: function created() {
    var _this2 = this;

    this.$store.dispatch('presenter/fetchPresentation', this.$route.params.presentationId)
    // eslint-disable-next-line
    .then(function () {
      return _this2.loading = false;
    }).catch(function () {
      window.alert('Failed to load presentation.');
      _this2.$router.go(-1);
    });
  },
  mounted: function mounted() {
    document.onkeydown = this.onKeyup;
    document.addEventListener('mousemove', this.onMousemove);
    document.addEventListener('webkitfullscreenchange', this.onFullscreenChange);
    document.addEventListener('mozfullscreenchange', this.onFullscreenChange);
    document.addEventListener('msfullscreenchange', this.onFullscreenChange);
    document.addEventListener('fullscreenchange', this.onFullscreenChange);
  },
  beforeDestroy: function beforeDestroy() {
    /* Make sure we get rid of the event listeners */
    window.removeEventListener('webkitfullscreenchange', this.onFullscreenChange);
    window.removeEventListener('mozfullscreenchange', this.onFullscreenChange);
    window.removeEventListener('msfullscreenchange', this.onFullscreenChange);
    window.removeEventListener('fullscreenchange', this.onFullscreenChange);
  }
});

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(290);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(205)("096d829e", content, true, {});

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(204)(true);
// imports


// module
exports.push([module.i, ".presenter{background-color:#000;display:grid;grid-gap:1em;grid-template-columns:1fr;grid-template-rows:auto 1fr;grid-template-areas:\"presenter-toolbar\" \"current-slide\"}.presenter.ui-hidden,.presenter.ui-hidden *{cursor:none!important}.presenter .presenter-toolbar,.presenter.ui-hidden:hover .presenter-toolbar{opacity:0;-webkit-transform:translateY(-100%);transform:translateY(-100%)}.presenter-toolbar{grid-area:presenter-toolbar;background-color:#000;-webkit-box-shadow:0 4px 0 rgba(0,0,0,.05);box-shadow:0 4px 0 rgba(0,0,0,.05);z-index:2;display:grid;grid-template-columns:repeat(3,1fr);-webkit-box-align:center;-ms-flex-align:center;align-items:center;justify-items:center}.presenter-toolbar .left{justify-self:start;display:grid;grid-template-columns:auto 1fr}.presenter-toolbar .left .brand{background-color:var(--primary-colour);border-radius:0;fill:rgba(0,0,0,.2);-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.presenter-toolbar .left .brand,.presenter-toolbar .left .title{padding:1em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.presenter-toolbar .left .title{font-size:1.1em;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.presenter-toolbar .controls{display:grid;-webkit-box-align:center;-ms-flex-align:center;align-items:center;grid-gap:1em;justify-items:center;grid-template-columns:repeat(3,1fr)}.presenter-toolbar .controls .index{font-size:1.2em}.presenter-toolbar .right{justify-self:end;padding-right:1em;display:grid;grid-gap:1em;grid-template-columns:1fr 1fr;justify-items:end}.presenter-toolbar .right a{grid-template-columns:auto 1fr}.presenter-toolbar a{display:grid;border-radius:5px;padding:.5em .7em;grid-gap:1em;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.presenter-toolbar a:hover{background-color:hsla(0,0%,100%,.2)}.presenter:hover .presenter-toolbar{opacity:1;-webkit-transform:none;transform:none;-webkit-transition:all .4s;transition:all .4s}.presenter .current-slide g:hover{cursor:default}.presenter .current-slide g .bbox,.presenter .current-slide g.inspecting .bbox,.presenter .current-slide g:hover .bbox{stroke:none}", "", {"version":3,"sources":["/home/forge/slidekick.daniel-waghorn.com/src/components/Presenter.vue"],"names":[],"mappings":"AACA,WACE,sBAAwB,AAExB,aAAc,AACd,aAAc,AACd,0BAA2B,AAC3B,4BAA6B,AAC7B,uDAGC,CACF,AACD,4CAEE,qBAAwB,CACzB,AACD,4EAEE,UAAW,AACX,oCAAqC,AAC7B,2BAA6B,CACtC,AACD,mBACE,4BAA6B,AAC7B,sBAAwB,AACxB,2CAAgD,AACxC,mCAAwC,AAChD,UAAW,AAEX,aAAc,AACd,oCAAsC,AACtC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAsB,CACvB,AACD,yBACE,mBAAoB,AACpB,aAAc,AACd,8BAAgC,CACjC,AACD,gCACE,uCAAwC,AACxC,gBAAiB,AACjB,oBAAyB,AAWzB,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,gEAdE,YAAa,AAEb,oBAAqB,AAErB,oBAAqB,AAErB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAiB7B,AAZD,gCACE,gBAAiB,AAQjB,uBAAwB,AACpB,oBAAqB,AACjB,0BAA4B,CACrC,AACD,6BACE,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,aAAc,AACd,qBAAsB,AACtB,mCAAsC,CACvC,AACD,oCACE,eAAiB,CAClB,AACD,0BACE,iBAAkB,AAClB,kBAAmB,AACnB,aAAc,AACd,aAAc,AACd,8BAA+B,AAC/B,iBAAmB,CACpB,AACD,4BACE,8BAAgC,CACjC,AACD,qBACE,aAAc,AACd,kBAAmB,AACnB,kBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,2BACE,mCAA2C,CAC5C,AACD,oCACE,UAAW,AACX,uBAAwB,AAChB,eAAgB,AACxB,2BAA6B,AAC7B,kBAAqB,CACtB,AACD,kCACE,cAAgB,CACjB,AACD,uHAGE,WAAa,CACd","file":"Presenter.vue","sourcesContent":["\n.presenter {\n  background-color: black;\n\n  display: grid;\n  grid-gap: 1em;\n  grid-template-columns: 1fr;\n  grid-template-rows: auto 1fr;\n  grid-template-areas:\n    \"presenter-toolbar\"\n    \"current-slide\"\n  ;\n}\n.presenter.ui-hidden,\n.presenter.ui-hidden * {\n  cursor: none !important;\n}\n.presenter .presenter-toolbar,\n.presenter.ui-hidden:hover .presenter-toolbar {\n  opacity: 0;\n  -webkit-transform: translateY(-100%);\n          transform: translateY(-100%);\n}\n.presenter-toolbar {\n  grid-area: presenter-toolbar;\n  background-color: black;\n  -webkit-box-shadow: 0 4px 0 rgba(0, 0, 0, 0.05);\n          box-shadow: 0 4px 0 rgba(0, 0, 0, 0.05);\n  z-index: 2;\n\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  justify-items: center;\n}\n.presenter-toolbar .left {\n  justify-self: start;\n  display: grid;\n  grid-template-columns: auto 1fr;\n}\n.presenter-toolbar .left .brand {\n  background-color: var(--primary-colour);\n  border-radius: 0;\n  fill: rgba(0, 0, 0, 0.2);\n  padding: 1em;\n\n  display: -webkit-box;\n\n  display: -ms-flexbox;\n\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.presenter-toolbar .left .title {\n  font-size: 1.1em;\n  padding: 1em;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n.presenter-toolbar .controls {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  grid-gap: 1em;\n  justify-items: center;\n  grid-template-columns: repeat(3, 1fr);\n}\n.presenter-toolbar .controls .index {\n  font-size: 1.2em;\n}\n.presenter-toolbar .right {\n  justify-self: end;\n  padding-right: 1em;\n  display: grid;\n  grid-gap: 1em;\n  grid-template-columns: 1fr 1fr;\n  justify-items: end;\n}\n.presenter-toolbar .right a {\n  grid-template-columns: auto 1fr;\n}\n.presenter-toolbar a {\n  display: grid;\n  border-radius: 5px;\n  padding: 0.5em 0.7em;\n  grid-gap: 1em;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.presenter-toolbar a:hover {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n.presenter:hover .presenter-toolbar {\n  opacity: 1;\n  -webkit-transform: none;\n          transform: none;\n  -webkit-transition: all 0.4s;\n  transition: all 0.4s;\n}\n.presenter .current-slide g:hover {\n  cursor: default;\n}\n.presenter .current-slide g .bbox,\n.presenter .current-slide g:hover .bbox,\n.presenter .current-slide g.inspecting .bbox {\n  stroke: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"presenter",class:_vm.computedStyles,on:{"click":_vm.touchscreenTrigger}},[_c('div',{staticClass:"presenter-toolbar"},[_c('div',{staticClass:"left"},[_c('router-link',{staticClass:"brand",attrs:{"to":"/"}},[_c('svg',{attrs:{"preserveAspectRatio":"xMidYMid meet","width":"40","height":"40","viewBox":"0 0 155 117","xmlns":"http://www.w3.org/2000/svg"}},[_c('symbol',{attrs:{"id":"logo"}},[_c('path',{attrs:{"d":"M91 97L25 20H10a10 10 0 1 1 0-20h135a10 10 0 0 1 0 20H63l66 77h16a10 10 0 0 1 0 20H10a10 10 0 0 1 0-20h81z"}})]),_vm._v(" "),_c('use',{attrs:{"xlink:href":"#logo"}})])]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.presentation.title))])],1),_vm._v(" "),_c('div',{staticClass:"controls"},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.previous}},[_c('i',{staticClass:"material-icons"},[_vm._v("chevron_left")])]),_vm._v(" "),_c('span',{staticClass:"index"},[_vm._v("\n        "+_vm._s(_vm.selectedSlideIndex + 1)+" / "+_vm._s(_vm.presentation.slides.length)+"\n      ")]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.next}},[_c('i',{staticClass:"material-icons"},[_vm._v("chevron_right")])])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('router-link',{attrs:{"to":{ name: 'editor', params: { presentationId: _vm.presentation.id }}}},[_c('i',{staticClass:"material-icons"},[_vm._v("keyboard_arrow_left")]),_vm._v(" Back to Editor\n      ")]),_vm._v(" "),(_vm.supportsFullscreen && !_vm.fullscreen)?_c('a',{attrs:{"href":"#"},on:{"click":_vm.enterFullscreen}},[_c('i',{staticClass:"material-icons"},[_vm._v("fullscreen")]),_vm._v(" Fullscreen\n      ")]):_vm._e(),_vm._v(" "),(_vm.supportsFullscreen && _vm.fullscreen)?_c('a',{attrs:{"href":"#"},on:{"click":_vm.exitFullscreen}},[_c('i',{staticClass:"material-icons"},[_vm._v("fullscreen_exit")]),_vm._v(" Exit Fullscreen\n      ")]):_vm._e()],1)]),_vm._v(" "),_c('current-slide',{attrs:{"slides":_vm.slides,"selected-slide-index":_vm.selectedSlideIndex}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.2337b1f4d6c397cef40f.js